module.exports = __webpack_public_path__ + "static/media/hero-laptop-rotated.e520e268.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/hero-laptop-rotated.png
// module id = 315
// module chunks = 0